module.exports = __webpack_public_path__ + "img/safemoon_normal_dark.fe09a7bc.svg";